var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_8408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82772 1.26648C3.09018 1.00441 3.40534 0.801114 3.75231 0.670061C4.09929 0.539009 4.47015 0.483192 4.84033 0.506311C5.2105 0.529429 5.57154 0.630954 5.89951 0.804158C6.22748 0.977362 6.5149 1.21829 6.74272 1.51098L9.43522 4.96998C9.92872 5.60448 10.1027 6.43098 9.90772 7.21098L9.08722 10.496C9.0448 10.6661 9.04709 10.8443 9.09387 11.0133C9.14065 11.1823 9.23034 11.3364 9.35422 11.4605L13.0397 15.146C13.164 15.2701 13.3183 15.3599 13.4875 15.4067C13.6568 15.4535 13.8354 15.4557 14.0057 15.413L17.2892 14.5925C17.6741 14.4962 18.0759 14.4888 18.4641 14.5706C18.8524 14.6525 19.2169 14.8215 19.5302 15.065L22.9892 17.756C24.2327 18.7235 24.3467 20.561 23.2337 21.6725L21.6827 23.2235C20.5727 24.3335 18.9137 24.821 17.3672 24.2765C13.409 22.8838 9.81513 20.6177 6.85222 17.6465C3.88115 14.684 1.61513 11.0907 0.222218 7.13298C-0.320782 5.58798 0.166718 3.92748 1.27672 2.81748L2.82772 1.26648Z",
    fill: "#A1B7DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_8408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFill);
export default __webpack_public_path__ + "static/media/phoneFill.87842c084f89295723fc78df75fe1842.svg";
export { ForwardRef as ReactComponent };